<app-doc-viewer
  title="Catalog"
  subtitle="Geo"
  [dependencies]="['ConfigService', 'LanguageService']"
>
  <app-example-viewer codeFolder="geo/catalog">
    <igo-map-browser [map]="map" [view]="view">
      <div class="map-actions --vertical --bottom --right">
        <igo-zoom-button [map]="map" color="primary" />
      </div>
    </igo-map-browser>

    <igo-panel title="Catalog Library">
      <igo-catalog-library
        [addCatalogAllowed]="true"
        [store]="$any(catalogStore)"
        (catalogSelectChange)="onCatalogSelectChange($event)"
      />
    </igo-panel>

    <igo-panel title="Catalog Browser">
      <igo-catalog-browser
        [catalog]="catalog"
        [store]="$any(catalogItemStore)"
        [map]="map"
      />
    </igo-panel>
  </app-example-viewer>
</app-doc-viewer>
